import { render, staticRenderFns } from "./RoleGroupsList.vue?vue&type=template&id=4772b369&scoped=true&"
import script from "./RoleGroupsList.vue?vue&type=script&lang=ts&"
export * from "./RoleGroupsList.vue?vue&type=script&lang=ts&"
import style0 from "./RoleGroupsList.vue?vue&type=style&index=0&id=4772b369&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4772b369",
  null
  
)

export default component.exports